<template>
  <modal :showing="showing">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Confirmation</h6>
      <div class="closeFeature" @click="closeModal"></div>
    </d-card-header>
    <d-card-body v-html="text">
      <div id="calendar"></div>
    </d-card-body>
    <d-card-footer class="d-flex justify-content-between">
      <button class="btn btn-success" @click="confirm">Confirmer</button>
      <button class="btn btn-danger" @click="hide">Annuler</button>
    </d-card-footer>
  </modal>
</template>

<script>
import confirmModal from '../../../initializer/confirmModal';
import Modal from './Modal';

export default {
  name: 'confirmModal',
  components: { Modal },
  data() {
    return {
      showing: false,
      text: '',
      onConfirm: {},
      onCancel: {},
    };
  },
  methods: {
    closeModal() {
      this.showing = false;
    },
    hide() {
      if (typeof this.onCancel === 'function') {
        this.onCancel();
      }
      this.showing = false;
    },
    confirm() {
      // we must check if this.onConfirm is function
      if (typeof this.onConfirm === 'function') {
        // run passed function and then close the modal
        this.onConfirm();
        this.hide();
      } else {
        // we only close the modal
        this.hide();
      }
    },
    show(params) {
      this.text = params.text;
      // set callback function
      this.onConfirm = params.onConfirm;
      this.onCancel = params.onCancel;
      this.showing = true;
    },
  },
  beforeMount() {
    confirmModal.EventBus.$on('show', (params) => {
      this.show(params);
    });
  },
};
</script>

<style scoped>
.closeFeature {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
  cursor: pointer;
}
.closeFeature:hover {
  opacity: 1;
}
.closeFeature:before,
.closeFeature:after {
  position: absolute;
  left: 15px;
  content: " ";
  height: 25px;
  width: 2px;
  background-color: #333;
}
.closeFeature:before {
  transform: rotate(45deg);
}
.closeFeature:after {
  transform: rotate(-45deg);
}
</style>
